import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { useAppDispatch, useAppSelector } from 'universal-scripts'
import { useDialog } from '@hooks/useDialog'
import { closeTrialDialog } from 'src/store/slices/ui'

import './TrialBlockedDialog.css'

export default function TrialBlockedDialog() {
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector((state) => state.ui.isTrialDialogOpen)

  const handleClose = useCallback(() => {
    dispatch(closeTrialDialog())
  }, [dispatch])

  const { dialogRef, handleBackdropClick } = useDialog(isOpen, handleClose)

  return (
    <dialog
      id="trial-blocked-dialog"
      className="app-dialog"
      ref={dialogRef}
      onClick={handleBackdropClick}
      onCancel={handleClose}
    >
      <div className="dialog-inner">
        <h2>
          <span className="icon icon-lock-closed" />
          <FormattedMessage id="trial-blocked-dialog.title" />
        </h2>
        <p>
          <FormattedMessage id="trial-blocked-dialog.text" />{' '}
          <Link
            to="/pricing"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClose}
          >
            <FormattedMessage id="trial-blocked-dialog.pricing-link" />
          </Link>
        </p>
      </div>
    </dialog>
  )
}
